import axios from 'axios';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}



export default {
  apihrdcall() {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get("/crew/apihrd");
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
currency() {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get("/currency/cbo");
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
department() {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get("/crew/department");
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
position() {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get("/crew/position");
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
group() {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get("/crew/group");
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
detail(obj) {
    return new Promise(async (resolve, reject) => {
        try {
            // console.log(`crew/detail/${obj.crewkey}`);
            const {data} = await axios.get(`crew/detail/${obj.crewkey}`);
            // const { data } = await axios.get(`crew/${obj.crewkey}`);
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
list(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['page', 'limit', 'sortBy', 'sortDir', 'compcode','crewnik', 'crewname', 'jabatan', 'departemen', 'pangkat', 'golongan', 'managerInfo', 'terminate','officer'];

            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }

            const url = `/crew${str}`;
            const { data } = await axios.get(url);
            const { meta, list } = data;
            obj.total = meta.total;
            resolve(list);
        } catch (error) {
            errorHandler(error, reject);
        }
    });
},
lookup(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['page', 'limit', 'sortBy', 'sortDir', 'compcode','crewnik', 'crewname', 'jabatan', 'departemen', 'pangkat', 'golongan', 'managerInfo', 'terminate','officer', 'isdeleted'];

            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }

            const url = `/crew/lookup${str}`;
            const { data } = await axios.get(url);
            const { meta, list } = data;
            obj.total = meta.total;
            resolve(list);
        } catch (error) {
            errorHandler(error, reject);
        }
    });
},
exportxls(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['sortBy', 'sortDir', 'crewnik', 'crewname', 'jabatan', 'departemen', 'pangkat', 'golongan', 'managerInfo', 'terminate', 'officer'];

            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }

            let response = await axios({
                url: `/crew/exportxls${str}`,
                method: 'GET',
                responseType: 'blob', // important
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `employee_List.xlsx`);
            document.body.appendChild(link);
            link.click();
            resolve(link);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
remove(obj) {
    return new Promise(async (resolve, reject) => {
        try {
            const resp = await axios.delete(`/crew/${obj.crewkey}`);
            resolve(resp);
        } catch (error) {
            errorHandler(error, reject);
        }
    })
},
save(data) {
    return new Promise(async (resolve, reject) => {
        try {
            // delete data.materials;
            const resp = await axios.post('/crew', data);
            resolve(resp);
        } catch (error) {
            errorHandler(error, reject);
        }
    });
},
taxgroup() {
    return new Promise(async (resolve, reject) => {
        try {
            const { data } = await axios.get(`/crew/taxgroup`);
            resolve(data);
        } catch (error) {
            errorHandler(error, reject);
        }
    });
}

};